import { render, staticRenderFns } from "./SmallResult.vue?vue&type=template&id=3c9214d0&scoped=true"
import script from "./SmallResult.vue?vue&type=script&lang=js"
export * from "./SmallResult.vue?vue&type=script&lang=js"
import style0 from "./SmallResult.vue?vue&type=style&index=0&id=3c9214d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9214d0",
  null
  
)

export default component.exports